import { render, staticRenderFns } from "./cHeadbar.vue?vue&type=template&id=56379988&scoped=true&lang=pug"
import script from "./cHeadbar.vue?vue&type=script&lang=js"
export * from "./cHeadbar.vue?vue&type=script&lang=js"
import style0 from "./cHeadbar.vue?vue&type=style&index=0&id=56379988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56379988",
  null
  
)

export default component.exports